import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import UserAvatar from '../../../userAvatar';
import ActionButton from '../../../actionButton';
import { ACTION_BUTTON_TYPES } from '../../../actionButton/config';
import { ReactComponent as CalendarIcon } from '../../../../../assets/icons/event_note.svg';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: spacing(1),
  },
  titleContent: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    marginRight: spacing(2),
  },
  modelIcon: {
    width: 16,
    height: 16,
    marginRight: spacing(2),
    flexShrink: 0,
    '& path': {
      fill: primary.bluish1,
    },
  },
  title: {
    marginTop: spacing(0.5),
    minWidth: 0,
  },
  markAsReadIcon: {
    width: 18,
    height: 15,
  },
  user: {
    marginBottom: spacing(2),
  },
  dateWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: spacing(1),
    marginLeft: spacing(1),
  },
  calendarIcon: {
    marginTop: spacing(-1),
    marginRight: spacing(2),
    flexShrink: 0,
  },
}));

const DocumentExpiredNotification = ({ translations, data, onMarkAsRead }) => {
  const classes = useStyles();
  const { user, expireDate, icon: Icon } = data;

  const handleMarkAsRead = useCallback(
    event => {
      event.preventDefault();
      event.stopPropagation();
      onMarkAsRead(data.id);
    },
    [data.id, onMarkAsRead]
  );

  return (
    <div className={classes.root}>
      <div className={classes.titleRow}>
        <div className={classes.titleContent}>
          {Icon && <Icon className={classes.modelIcon} />}
          <Typography className={classes.title} variant="overline">
            {translations.title}
          </Typography>
        </div>
        <ActionButton
          iconClass={classes.markAsReadIcon}
          type={ACTION_BUTTON_TYPES.MARK_AS_READ}
          tooltipText={translations.markAsRead}
          onClickHandler={handleMarkAsRead}
        />
      </div>
      {user && (
        <UserAvatar
          className={classes.user}
          user={user}
          variant="subtitle2"
          extraSmall
          caption
        />
      )}
      {expireDate && (
        <div className={classes.dateWrapper}>
          <CalendarIcon className={classes.calendarIcon} />
          <Typography variant="body2">{expireDate}</Typography>
        </div>
      )}
    </div>
  );
};

DocumentExpiredNotification.propTypes = {
  translations: PropTypes.object.isRequired,
  data: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    user: PropTypes.object,
    documentType: PropTypes.string,
    expireDate: PropTypes.string,
    icon: PropTypes.elementType,
  }).isRequired,
  onMarkAsRead: PropTypes.func.isRequired,
};

export default DocumentExpiredNotification;
